import * as actionTypes from "./actionTypes";

export const getAllDocumentations = () => ({
  type: actionTypes.GET_ALL_DOCUMENTATIONS,
});

export const getDocumentById = (id) => ({
  type: actionTypes.GET_DOCUMENT_BY_ID,
  id,
});

export const createDocument = (payload) => ({
  type: actionTypes.CREATE_DOCUMENT,
  payload,
});

export const updateDocumentById = (id, payload) => ({
  type: actionTypes.UPDATE_DOCUMENT_BY_ID,
  id,
  payload,
});

export const deleteDocumentById = (id, resp) => ({
  type: actionTypes.DELETE_DOCUMENT_BY_ID,
  id,
  resp,
});

export const exportDocuments = () => ({
  type: actionTypes.EXPORT_DOCUMENTS,
});

export const importDocuments = (payload) => ({
  type: actionTypes.IMPORT_DOCUMENTS,
  payload,
});
